export default {
  List: "/pyr/payslip-templates",
  Create: "/pyr/payslip-templates",
  Update: "/pyr/payslip-templates",
  Detail: "/pyr/payslip-templates",
  Delete: "/pyr/payslip-templates",
};
